function updatVariantSelectionQuickView(form){
    const opt1Element = form.querySelector("input[name='option1']:checked") || form.querySelector("select[name='option1']");
    const opt2Element = form.querySelector("input[name='option2']:checked") || form.querySelector("select[name='option2']");
    const opt3Element = form.querySelector("input[name='option3']:checked") || form.querySelector("select[name='option3']");

    const opt1 = opt1Element ? opt1Element.value : 'null';
    const opt2 = opt2Element ? opt2Element.value : 'null';
    const opt3 = opt3Element ? opt3Element.value : 'null';

    const masterVariantsSelect =  form.querySelector("#variant_match");

    console.log(opt1, opt2, opt3);

    masterVariantsSelect.querySelectorAll("option").forEach((opts, j)=>{
        if(opts.dataset.option1 == opt1 && opts.dataset.option2 == opt2 && opts.dataset.option3 == opt3 ){
            masterVariantsSelect.value = opts.value;
            //console.log(masterVariantsSelect.price);
            form.querySelector('select[name="id"]').value = opts.value;
            form.querySelector('.main_price').textContent = opts.dataset.price;
            form.querySelector('.price_compare').textContent = opts.dataset.compareAtPrice;
            if(window.hasColor){
            }else {
                form.querySelectorAll(".all-images .swiper-slide").forEach((sliding, index)=>{
                    if(sliding.querySelector('img') && sliding.querySelector('img').drc == opts.dataset.mainImgSrc){
                        const Index = sliding.dataset.index;
                        window.swiper.slideTo(Index);
                        window.swiper2.slideTo(Index);
                    }
                });
            }
            if(opts.dataset.available == 'true'){
                const buttonHtml = document.querySelector('.button-inner-html').innerHTML;
                form.querySelector('.cart_Add-btn').innerHTML = buttonHtml;
                form.querySelector('.cart_Add-btn').disabled = false;
                if(form.querySelector('.container_bt button[type="submit"]')){
                    form.querySelector('.container_bt button[type="submit"]').innerHTML = buttonHtml;
                    form.querySelector('.container_bt button[type="submit"]').disabled = false;
                }
            }else {
                const buttonHtml = 'Sold out';
                form.querySelector('.cart_Add-btn').innerHTML = buttonHtml;
                form.querySelector('.cart_Add-btn').disabled = true;
                if(form.querySelector('.container_bt button[type="submit"]')){
                    form.querySelector('.container_bt button[type="submit"]').innerHTML = buttonHtml;
                    form.querySelector('.container_bt button[type="submit"]').disabled = true;
                }
            }
        }
    });
    if(form.querySelector('.option_name span')){
        form.querySelector('.option_name span').textContent = opt1;
    }
    if(form.querySelector(`.flex_sizes select[id="option1"]`)){
        form.querySelector(`.flex_sizes select[id="option1"]`).value = opt1;
    }
    if(form.querySelector(`.flex_sizes select[id="option2"]`)){
        form.querySelector(`.flex_sizes select[id="option2"`).value = opt2;
    }
    if(form.querySelector(`.flex_sizes select[id="option3"]`)){
        form.querySelector(`.flex_sizes select[id="option3"`).value = opt3;
    }
}


document.querySelectorAll('.popup-similar-products .mains_product_popup form').forEach(form => {
    console.log(form);
    form.addEventListener('change', function(){
        console.log('chnage Data');
        updatVariantSelectionQuickView(form);
    })

    updatVariantSelectionQuickView(form); 
})